import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  Typography,
  Box,
  Grid,
  CircularProgress,
  FormHelperText,
  Icon,
  Tooltip,
  Button,
} from '@mui/material'

import { FileUploaderAgnostic, UploadTooltip } from '../../../../ui'
import { toast } from 'react-toastify'
import { ROOT_CERTIFICATES_DOCUMENTS } from '../../constants'

const AttachField = ({ label, data, showErrors, errors = {}, updateInfo, ...restProps }) => {
  const { formatMessage } = useIntl()
  const [disabled, setDisabled] = React.useState(false)
  const CAN_BE_DISABLED = ['CCEE', 'CB', 'CPI']
  useEffect(() => {
    if (!data['campana']) {
      if (CAN_BE_DISABLED.includes(restProps.field)) {
        if (restProps.field === 'CPI' && data['tipo_solicitud'] !== 'instalador') {
          setDisabled(false)
        } else {
          setDisabled(true)
        }
      }
    }
  }, [])
  const handleUploadCertificateFile = (info, type) => {
    //Info as it should be submitted to BE
    updateInfo(info)
    //Update info as back would return it so that the file is already displayed on screen
    updateInfo({
      target: {
        name: 'd_' + type + '_id',
        value: '-1',
      },
    })
    updateInfo({
      target: {
        name: 'd_' + type + '_nombre',
        value: info.target.value.name.split('.').slice(0, -1).join('.'),
      },
    })
    updateInfo({
      target: {
        name: 'd_' + type + '_extension',
        value: info.target.value.type,
      },
    })
  }

  const handleFileUploadError = (data) => {
    toast.error(
      <>
        <Icon>error_outlined</Icon>
        <Typography
          variant="body1"
          display="inline"
          style={{ verticalAlign: 'super', marginLeft: 8 }}
        >
          {data.mssg}
        </Typography>
      </>
    )
  }
  if (restProps.field === 'tallo_i' && !data['presupuesto_id']) return null
  return (
    <Box sx={{ mb: 2 }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
      >
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography variant="body1">{label}</Typography>
          <UploadTooltip file={restProps} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap={1}
          sx={{ minWidth: '200px' }}
        >
          {data['d_' + restProps.field + '_id'] && (
            <Typography variant="body2" noWrap sx={{ maxWidth: '300px' }}>
              {data['d_' + restProps.field + '_nombre'] +
                '.' +
                data['d_' + restProps.field + '_extension']}
            </Typography>
          )}
          <FileUploaderAgnostic
            applicationId={data['solicitud_id']}
            clientId={data['client_id']}
            onSuccess={(info) => handleUploadCertificateFile(info, restProps.field)}
            onError={handleFileUploadError}
            name={restProps.field}
            //Comment: we save by field and not by type to locate them easily from the config list
            idName={restProps.field}
            disabled={disabled}
            {...restProps}
          >
            {(props) => {
              const button = (
                <Button 
                  variant="outlined" 
                  sx={{ 
                    whiteSpace: 'nowrap',
                    pointerEvents: props.disabled ? 'auto' : 'none',
                    opacity: props.disabled ? 0.6 : 1
                  }}
                >
                  {props.loading ? (
                    <CircularProgress size={20} />
                  ) : (
                    formatMessage({ id: 'pages.certificates.documents.button.add' })
                  )}
                </Button>
              )

              if (props.disabled) {
                return (
                  <Tooltip
                    title={formatMessage({ id: 'pages.certificates.documents.button.disabled' })}
                  >
                    <span>{button}</span>
                  </Tooltip>
                )
              }

              return button
            }}
          </FileUploaderAgnostic>
        </Box>
      </Box>
      {showErrors && errors[restProps.id] && (
        <FormHelperText error>Este documento es obligatorio</FormHelperText>
      )}
    </Box>
  )
}

export const CertificateDocuments = ({ documentList, data, updateInfo, showErrors, errors }) => {
  const { formatMessage } = useIntl()
  return (
    <Box>
      <Typography variant="body1" color="primary" paragraph>
        {formatMessage({ id: 'pages.certificates.documents.title' })}
      </Typography>
      <Box sx={{ mt: 2 }}>
        {documentList.map((fieldProps, i) => {
          const label = formatMessage({ id: ROOT_CERTIFICATES_DOCUMENTS + '.' + fieldProps.label })
          return (
            <AttachField
              key={fieldProps.field}
              {...{ ...fieldProps, label, data, showErrors, updateInfo, errors }}
            />
          )
        })}
      </Box>
    </Box>
  )
}
